<template>
  <div id="app" style="position: relative;">
    <el-popover style="position: absolute; top: 60px;" transition="el-fade-in-linear" v-model="showMention"
      :visible-arrow="false" placement="top-start" width="300" trigger="manual" :inert="showMention ? false : true">
      <div class="overflow-auto" style="max-height: 400px">
        <div :key="index" v-for="(item, index) in itemsInMention">
          <div class="pointer pin d-flex rounded-1 align-items-center py-2 px-1"
            :class="selectedMention === index && 'mention-selected'" @click="addMentioned(item)">
            <el-avatar class="mx-2" :src="item.avatar" v-if="item.id != '-1'"
              style="min-width: 32px; min-height: 32px; max-width: 32px; max-height: 32px" />
            <div class="d-flex align-items-center" v-else>
              <el-avatar class="mx-2"
                src="https://chat.zalo.me/assets/icn_mentionall.b2c245e08bb8372941a2ae03865b67e4.png"
                style="min-width: 32px; min-height: 32px; max-width: 32px; max-height: 32px" />
              <div class="me-2">Báo cho cả nhóm</div>
            </div>
            <div v-bind:class="item.id === '-1' ? 'c-blue' : ''" class="me-2">
              {{ item.name }}
            </div>
          </div>
        </div>
      </div>
      <div slot="reference"></div>
    </el-popover>
    <vue-editor ref="editor" v-model="content" :editorToolbar="customToolbar">
    </vue-editor>
  </div>
</template>

<script>
import { VueEditor } from "vue2-quill-editor";

export default {
  components: {
    VueEditor,
  },
  props: ["conversation", "members", "newMessage", "mentions", "messageReplied", "showReplied"],

  watch: {
    content(newContent, oldContent) {
      const contentText = this.handleHtmlToPlainText(newContent);
      const oldContentText = this.handleHtmlToPlainText(oldContent);

      if (contentText !== oldContentText && contentText.includes('@')) {
        this.getMentionComponent();
      }
      else {
        this.showMention = false
      }

      //bỏ mention khi content không khớp mention
      this.listMentions = this.listMentions.filter(item => this.checkMention(contentText, item.name));

      if (newContent) {
        this.listMentions.forEach(item => {
          if (!this.checkMention(contentText, item.name)) {
            const member = JSON.parse(JSON.stringify(this.members)).find(s => s.id === item.uid);
            if (member) this.itemsInMention.push(member);
          }
        })
      }
    },
  },

  data() {
    return {
      customToolbar: [
        ["bold", "italic", "underline", "strike"],
        [{ size: ["small", false, "large", "huge"] }], // Cỡ chữ
        [{ color: ["#DB342E", "#F27806", "#F7B503", "#15A85F", "#050A19"] }], // Màu chữ
        [{ list: "ordered" }, { list: "bullet" }], // Đánh số, gạch đầu dòng
        [{ indent: "-1" }, { indent: "+1" }], // Lùi đầu dòng
        ["clean"], // Xóa định dạng
        [
          {
            content: "customUndo",
            onclick: () => this.editor.history.undo(),
          },
          {
            content: "customRedo",
            onclick: () => this.editor.history.redo(),
          },
        ],
      ],
      content: "",
      listMentions: [],
      searchTextMention: "",
      showMention: false,
      selectedMention: 0,
    };
  },
  computed: {
    itemsInMention() {
      let index = this.members.findIndex((s) => s.id == "-1");
      let response = JSON.parse(JSON.stringify(this.members));
      if (index === -1) {
        let item = { id: "-1", name: "All" };
        response.unshift(item);
      }
      if (this.searchTextMention) {
        let arr = response.filter((s) => {
          return s.name.toLowerCase().includes(this.searchTextMention.toLowerCase());
        });
        if (arr.length === 0) {
          // eslint-disable-next-line vue/no-side-effects-in-computed-properties
          this.showMention = false;
        }
        if (this.listMentions.length > 0) {
          return arr.filter((s) => !this.listMentions.map((t) => t.uid).includes(s.id));
        }
        return arr;
      } else {
        if (this.listMentions.length > 0) {
          return response.filter((s) => !this.listMentions.map((t) => t.uid).includes(s.id));
        }
        return response;
      }
    },
  },
  methods: {
    decodeHtml(html) {
      let txt = document.createElement("textarea");
      txt.innerHTML = html;
      return txt.value;
    },
    refactorListMentions() {
      let arr = [];
      let plainContent = this.handleHtmlToPlainText(this.content);
      this.listMentions.forEach(v => {
        let name = "@" + v.name;
        let startIndex = 0;
        let index;
        while ((index = plainContent.indexOf(name, startIndex)) !== -1) {
          arr.push({
            name: name,
            uid: v.uid,
            pos: index,
            length: name.length
          });
          startIndex = index + name.length;
        }
      });
      arr.sort((a, b) => a.pos - b.pos);
      this.listMentions = arr;
      return this.listMentions;
    },
    EmojiPickup(emoji) {
      this.content = this.content += emoji;
    },
    QuickMessagePickup(message) {
      this.content = message.content;
    },
    // parseHtmlToObject(html) {

    //   const object = {
    //     content: "",
    //     params: ""
    //   };

    //   const parser = new DOMParser();
    //   const doc = parser.parseFromString(html, "text/html");
    //   const textNodes = [];
    //   let cursor = 0;
    //   let isFirstP = true;

    //   const styles = [];

    //   const processNode = (node) => {
    //     if (node.nodeType === Node.TEXT_NODE) {
    //       const text = node.textContent;
    //       textNodes.push({ text, start: cursor });
    //       cursor += text.length;
    //     } else if (node.nodeType === Node.ELEMENT_NODE) {
    //       const style = {};

    //       if (node.tagName === 'P' || node.tagName === "LI") {
    //         if (!isFirstP) {
    //           const lineBreak = '\n';
    //           textNodes.push({ text: lineBreak, start: cursor });
    //           cursor += lineBreak.length;
    //         }
    //         isFirstP = false;
    //       }

    //       if (node.style.fontWeight === "bold" || node.tagName === 'STRONG') style.b = 'b';
    //       if (node.style.fontStyle === "italic" || node.tagName === 'EM') style.i = 'i';
    //       if (node.style.textDecoration.includes("underline") || node.tagName === 'U') style.u = 'u';
    //       if (node.style.textDecoration.includes("line-through") || node.tagName === 'S') style.s = 's';
    //       if (node.style.fontSize) style.f = `f_${parseInt(node.style.fontSize)}`;
    //       if (node.style.color) {
    //         const rgbColor = node.style.color;
    //         const hexColor = rgbColor.startsWith("rgb") ? this.rgbToHex(...rgbColor.match(/\d+/g).map(Number)) : rgbColor;
    //         style.c = `c_${hexColor.slice(1)}`;
    //       }
    //       if (node.tagName === "LI") {
    //         style.lst = node.parentElement.tagName === "UL" ? "lst_1" : "lst_2";
    //       }
    //       if (node.style.paddingLeft) {
    //         style.ind = `ind_${parseInt(node.style.paddingLeft)}`;
    //       }
    //       if (node.classList.contains('ql-size-huge')) {
    //         style.f = "f_20";
    //       }
    //       if (node.classList.contains('ql-size-large')) {
    //         style.f = "f_18";
    //       }
    //       if (node.classList.contains('ql-size-small')) {
    //         style.f = "f_13";
    //       }

    //       const start = cursor;
    //       node.childNodes.forEach(processNode);
    //       const len = cursor - start;

    //       if (Object.keys(style).length > 0) {
    //         const styleString = Object.values(style).join(",");
    //         styles.push({ start, len, st: styleString });
    //       }
    //     }
    //   };

    //   processNode(doc.body);
    //   object.content = JSON.stringify({
    //     thumb: "",
    //     description: "",
    //     action: "rtf",
    //     childnumber: 0,
    //     href: "",
    //     title: textNodes.map(t => t.text).join(""),
    //   });
    //   object.params = JSON.stringify({ styles, ver: 0 });

    //   return object;
    // },
    parseHtmlToObject(html) {
      const object = {
        content: "",
        params: ""
      };

      const parser = new DOMParser();
      const doc = parser.parseFromString(html, "text/html");
      const textNodes = [];
      let cursor = 0;
      let isFirstP = true;

      let styles = [];

      const processNode = (node) => {
        if (node.nodeType === Node.TEXT_NODE) {
          const text = node.textContent;
          textNodes.push({ text, start: cursor });
          cursor += text.length;
        } else if (node.nodeType === Node.ELEMENT_NODE) {
          const style = {};

          if (node.tagName === 'P' || node.tagName === "LI") {
            if (!isFirstP) {
              const lineBreak = '\n';
              textNodes.push({ text: lineBreak, start: cursor });
              cursor += lineBreak.length;
            }
            isFirstP = false;
          }

          const fwRaw = node.style.fontWeight;
          const fwNum = parseInt(fwRaw, 10);
          const isBoldWeight = fwRaw === "bold" || fwRaw === "bolder" || (Number.isFinite(fwNum) && fwNum >= 600);
          if (isBoldWeight || node.tagName === 'STRONG' || node.tagName === 'B') style.b = 'b';
          const fsRaw = node.style.fontStyle;
          if (fsRaw === "italic" || fsRaw === "oblique" || node.tagName === 'EM' || node.tagName === 'I') style.i = 'i';
          if (node.style.textDecoration.includes("underline") || node.tagName === 'U') style.u = 'u';
          if (node.style.textDecoration.includes("line-through") || node.tagName === 'S' || node.tagName === 'STRIKE' || node.tagName === 'DEL') style.s = 's';
          if (node.style.fontSize) style.f = `f_${parseInt(node.style.fontSize)}`;
          if (node.style.color) {
            const rgbColor = node.style.color;
            const hexColor = rgbColor.startsWith("rgb")
              ? this.rgbToHex(...rgbColor.match(/\d+/g).map(Number))
              : rgbColor;
            style.c = `c_${hexColor.slice(1)}`;
          }
          if (node.tagName === "LI") {
            style.lst = node.parentElement.tagName === "UL" ? "lst_1" : "lst_2";
          }
          if (node.style.paddingLeft) {
            style.ind = `ind_${parseInt(node.style.paddingLeft)}`;
          }
          if (node.classList.contains('ql-size-huge')) {
            style.f = "f_20";
          }
          if (node.classList.contains('ql-size-large')) {
            style.f = "f_18";
          }
          if (node.classList.contains('ql-size-small')) {
            style.f = "f_13";
          }

          const start = cursor;
          node.childNodes.forEach(processNode);
          const len = cursor - start;

          if (Object.keys(style).length > 0) {
            // 🔥 Bỏ qua nếu đoạn text nằm trong mention
            const isInMention = this.listMentions.some(m => {
              return (start < (m.pos + m.length)) && ((start + len) > m.pos);
            });

            if (!isInMention) {
              const styleString = Object.values(style).join(",");
              styles.push({ start, len, st: styleString });
            }
          }
        }
      };

      processNode(doc.body);
      object.content = JSON.stringify({
        thumb: "",
        description: "",
        action: "rtf",
        childnumber: 0,
        href: "",
        title: textNodes.map(t => t.text).join(""),
      });
      object.params = JSON.stringify({ styles, ver: 0 });

      return object;
    },
    rgbToHex(r, g, b) {
      const toHex = (value) => {
        const hex = value.toString(16);
        return hex.length === 1 ? "0" + hex : hex;
      };
      return `#${toHex(r)}${toHex(g)}${toHex(b)}`;
    },
    sendMessageForm() {
      if (this.content.length == 0) {
        this.$message.error("Nhập nội dung cần gửi.");
        return;
      }
      // Xử lý content ở đây
      const messageObj = this.parseHtmlToObject(this.content.trim().replace(/^\s+/gm, ''));

      const message = JSON.parse(messageObj.content).title; // xử lý content ở đây
      const textProperties = JSON.stringify({
        styles: JSON.parse(messageObj.params).styles,
        ver: 0
      });
      const mentions = this.refactorListMentions();
      if (this.conversation.group) {
        let req = {
          accountId: this.conversation.accountId,
          groupId: this.conversation.toId,
          message: message,
          textProperties: textProperties,
          mentions: mentions,
        };
        if (this.showReplied) {
          if (this.content.trim().length > 0) this.replyMessage(mentions, textProperties, message);
          return;
        }

        this.content = "";
        const mentionUrl = "/api/message/group/mention";
        this.$http
          .post(mentionUrl, req)
          .then((resp) => {
            if (!(resp && resp.data && resp.data.data && resp.data.data.msgId)) {
              this.$emit("sendFailed", { text: message, request: req, isGroup: true, url: mentionUrl });
            }
          })
          .catch(() => {
            this.$emit("sendFailed", { text: message, request: req, isGroup: true, url: mentionUrl });
          })
          .finally(() => {
            this.listMentions = [];
          });
      } else {
        let req = {
          accountId: this.conversation.accountId,
          toId: this.conversation.toId,
          message: message,
          conversationId: this.conversation.id,
          textProperties: textProperties,
        };
        this.content = "";
        const smsUrl = "/api/message/sms";
        this.$http.post(smsUrl, req)
          .then((resp) => {
            if (!(resp && resp.data && resp.data.data && resp.data.data.msgId)) {
              this.$emit("sendFailed", { text: message, request: req, isGroup: false, url: smsUrl });
            }
          })
          .catch(() => {
            this.$emit("sendFailed", { text: message, request: req, isGroup: false, url: smsUrl });
          });
      }
    },
    replyMessage(mentions, textProperties, messageContent) {
      let message = this.messageReplied;
      let request = {
        conversationId: this.conversation.id,
        toId: this.conversation.toId,
        accountId: this.conversation.accountId,
        message: messageContent,
        ownerId: message.id.uidFrom != "0" ? message.id.uidFrom : this.conversation.accountId,
        replyMsgId: message.id.msgId,
        replyMsgClientId: message.cliMsgId,
        replyMsgTs: message.ts,
        textProperties: textProperties,
        mentionInfo: JSON.stringify(mentions.map((s) => {
          return {
            uid: s.uid,
            pos: s.pos,
            len: s.length,
            type: 0
          };
        }))
      };
      let url;
      if (message.msgType === "webchat") {
        request.replyMsg = message.content;
        url = this.conversation.group ? "/api/message/replyGroupMessage" : "/api/message/replyMessage";
      } else if (message.msgType === "chat.photo" || message.msgType === "chat.video.msg") {
        let content = JSON.parse(message.content);
        content.oriUrl = content.hdUrl = content.normalUrl = content.href;
        content.thumbUrl = content.thumb;
        request.replyMsgAttach = content;
        request.group = this.conversation.group;
        if (message.msgType === "chat.video.msg") {
          request.replyMsgAttach.type = "44";
        }
        
        url = "/api/message/replyPhoto";
      } else if (this.isLinkMessage(message)) {
        url = "/api/message/replyPhoto";
        let content = JSON.parse(message.content);
        content.type = "38";
        request.replyMsgAttach = content;
        request.group = this.conversation.group;
      }

      const replyIsGroup = !!this.conversation.group;
      const replyText = request.message || "";
      this.$http
        .post(url, request)
        .then((resp) => {
          if (!(resp && resp.data && resp.data.data && resp.data.data.msgId)) {
            this.$emit("sendFailed", { text: replyText, request, isGroup: replyIsGroup, url });
          }
        })
        .catch(() => {
          this.$emit("sendFailed", { text: replyText, request, isGroup: replyIsGroup, url });
        });
      this.$emit('replyQuill');
      this.content = "";
    },
    handleHtmlToPlainText(html) {
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');

      const lines = [];
      doc.body.childNodes.forEach(node => {
        if (node.nodeType === Node.TEXT_NODE) {
          lines.push(node.textContent);
        } else if (node.nodeType === Node.ELEMENT_NODE) {
          lines.push(node.textContent);
          if (node.tagName === 'P' || node.tagName === 'DIV' || node.tagName === 'BR') {
            lines.push('\n');
          }
        }
      });
      
      return lines.join('');
    },
    restoreMention() {
      this.showMention = false;
      this.searchTextMention = null;
      this.selectedMention = 0;
    },
    addMentioned(item) {
      const contentText = this.content;
      const index = contentText.length;

      const contentParse = this.parseHtmlToObject(this.content);
      const position = this.getLastKeyBeforeCaret(contentParse.length).keyIndex;

      const keyIndex = contentText.lastIndexOf("@");
      const firstContent = contentText.substring(0, keyIndex + 1);
      const secondContent = contentText.substring(keyIndex + 1, index);
      this.content = firstContent + item.name + " " + secondContent;
      
      let mention = {};
      mention.name = item.name;
      mention.uid = item.id;
      mention.pos = position;
      mention.length = item.name.length + 1;

      this.listMentions.push(mention);
      if (item.id === '-1') {
        this.members.unshift({
          id: "-1",
          name: "All",
        });
      }

      this.$nextTick(() => {
        const editor = this.$refs.editor.quill;

        if (editor) {
          const cursorPos = this.content.substring(0, this.content.lastIndexOf("@") + 1).length + item.name.length + 1;
          const range = editor.getSelection();

          if (range) {
            editor.setSelection(cursorPos, 0);
          } else {
            editor.setSelection(cursorPos, 0);
          }
          editor.focus();
        }
      });
      this.restoreMention();
    },
    getMentionComponent() {
      const editor = this.$refs.editor.quill;
      if (!editor) return;

      const caretIndex = editor.getSelection()?.index || 0;
      const contentText = this.handleHtmlToPlainText(this.content);

      // Tìm @ gần nhất trước caret
      const lastAtIndex = contentText.lastIndexOf('@', caretIndex - 1);
      if (lastAtIndex === -1) {
        this.showMention = false;
        return;
      }

      // Text để filter mention
      const searchText = contentText.slice(lastAtIndex + 1, caretIndex).trim();

      this.searchTextMention = searchText;
      this.showMention = true;
    },
    getLastKeyBeforeCaret(caretIndex) {
      const contentText = this.handleHtmlToPlainText(this.content);
      let _this = contentText;
      const [keyData] = ["@"]
        .map((key) => ({
          key,
          keyIndex: _this.lastIndexOf(key, caretIndex - 1),
        }))
        .sort((a, b) => b.keyIndex - a.keyIndex);
      return keyData;
    },
    getLastSearchText(caretIndex, keyIndex) {
      const contentText = this.handleHtmlToPlainText(this.content);
      const caretPosition = this.getCaretPosition();

      if (keyIndex !== -1) {
        let searchText = null;

        if (caretIndex === keyIndex + 1) {
          searchText = contentText.substring(keyIndex + 1, caretIndex);
        } else {
          if (caretPosition === keyIndex + 1) {
            searchText = contentText.substring(keyIndex + 1, caretIndex);

            let endIndex = searchText.indexOf(" ");
            let result = endIndex === -1 ? searchText : searchText.substring(0, endIndex);

            if (result.length > 0) {
              searchText = result;
            } else {
              const nonSpace = searchText.length;
              searchText = searchText.slice(0, -(caretIndex - keyIndex - nonSpace - 1));
            }
          }
        }
        if (!/\s/.test(searchText)) {
          return searchText;
        }
      }
      return null;
    },
    getCaretPosition() {
      const editor = this.$refs.editor;
      const quill = editor.quill;
      const position = quill.getSelection();

      if (position) {
        return position.index;
      }
      return null;
    },
    checkMention(content, mention) {
      const regex = new RegExp(`\\${mention}(\\s|$)`);
      return regex.test(content);
    },
    setupClipboardMatchers() {
      // Quill mặc định chỉ chuyển <b>/<i>/<u> sang format. Khi paste từ Word/Google Docs/browser,
      // bold/italic thường nằm trong inline style `font-weight: 700` hoặc `font-style: italic`,
      // không được map sang Quill formats → editor render plain text. Matcher này bổ sung.
      const editor = this.$refs.editor && this.$refs.editor.quill;
      if (!editor || !editor.clipboard) return;
      const Quill = editor.constructor;
      const Delta = Quill.import("delta");

      editor.clipboard.addMatcher(Node.ELEMENT_NODE, (node, delta) => {
        const style = node.style;
        if (!style) return delta;

        const formats = {};
        const fwRaw = style.fontWeight;
        const fwNum = parseInt(fwRaw, 10);
        if (fwRaw === "bold" || fwRaw === "bolder" || (Number.isFinite(fwNum) && fwNum >= 600)) {
          formats.bold = true;
        }
        const fsRaw = style.fontStyle;
        if (fsRaw === "italic" || fsRaw === "oblique") {
          formats.italic = true;
        }
        const td = style.textDecoration || style.textDecorationLine || "";
        if (td.includes("underline")) formats.underline = true;
        if (td.includes("line-through")) formats.strike = true;

        if (!Object.keys(formats).length) return delta;
        return delta.compose(new Delta().retain(delta.length(), formats));
      });
    }
  },
  created() {
    this.$bus.$on("emoji_click", (data) => {
      this.EmojiPickup(data);
    });
    this.$bus.$on("selectQuickMessage", (data) => {
      this.QuickMessagePickup(data);
    });
    this.$bus.$on("sendMessageForm", () => {
      this.sendMessageForm();
    });
  },
  mounted() {
    if (this.newMessage.length > 0) {
      this.content = this.newMessage;
    }
    if (this.mentions) {
      this.listMentions = [...this.mentions];
    }
    this.$nextTick(() => this.setupClipboardMatchers());
  },
  beforeDestroy() {
    this.$bus.$off('sendMessageForm')
    this.$bus.$off('selectQuickMessage')
  }
};
</script>
<style>
.quillWrapper {
  width: 100%;
  border-right: thin solid #d3d7de;
}

#quill-container {
  height: 200px !important;
  width: 100%;
  border: none;
}

.ql-editor {
  padding: 0 !important;
}

.ql-toolbar.ql-snow {
  border: none !important;
  padding: 8px 0 !important;
  margin-left: -8px;
}
</style>